export default __webpack_public_path__ + "static/media/instagram.f2adc45f.svg";